import "./WhyUs.module.css";
import Navigation from "@/reusable_sections/Header";
import Edge from "./sections/Edge";
import Credentials from "./sections/Credentials";
import Protect from "./sections/Protect";
import Footer from "@/reusable_sections/Footer";
export default function WhyUsPage() {
  return <div>
      <Navigation />
      <Edge />
      <Credentials />
      <Protect />
      <Footer />
    </div>;
}